var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  staticClass: "large-icon",
                  attrs: { white: "", disabled: !_vm.canEdit },
                  on: {
                    click: function ($event) {
                      return _vm.edit()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
              _vm.isAccountant
                ? _c(
                    "w-toolbar-item",
                    {
                      staticClass: "large-icon",
                      attrs: { white: "", disabled: _vm.isPushingToExact },
                      on: {
                        click: function ($event) {
                          return _vm.pushToExact()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "cloud-upload-alt" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-toolbar-item",
                {
                  staticClass: "large-icon",
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          !_vm.$wf.isSmDown
            ? _c(
                "w-row",
                { attrs: { "no-wrap": "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-row",
                        { attrs: { "no-wrap": "" } },
                        [
                          _c("w-tabs", {
                            attrs: { tabs: _vm.tabs },
                            model: {
                              value: _vm.tab,
                              callback: function ($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab",
                            },
                          }),
                          _c("w-spacer"),
                          _vm.hasLedgerModule
                            ? _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("green-book"),
                                      expression: "$ct('green-book')",
                                    },
                                  ],
                                  staticClass: "edit-ledgers mr",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openLedgers()
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "ledger-icon mr",
                                    attrs: { icon: "book" },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$ct("green-book-split")) + " "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isAccountant
                            ? _c(
                                "w-button",
                                {
                                  staticClass: "push-to-exact mr",
                                  attrs: { disabled: _vm.isPushingToExact },
                                  on: {
                                    click: function ($event) {
                                      return _vm.pushToExact()
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mr",
                                    attrs: { icon: "cloud-upload-alt" },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$ct("push-to-exact")) + " "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isAccountant
                            ? _c(
                                "w-button",
                                {
                                  staticClass: "push-to-exact mr",
                                  attrs: {
                                    disabled: _vm.isPushingToClearfacts,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.pushToClearfacts()
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mr",
                                    attrs: { icon: "cloud-upload-alt" },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$ct("push-to-clearfacts")) + " "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "w-button",
                            {
                              staticClass: "cancel mr",
                              on: {
                                click: function ($event) {
                                  return _vm.cancel()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("common.cancel")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "w-button",
                            {
                              attrs: { disabled: !_vm.canEdit },
                              on: {
                                click: function ($event) {
                                  return _vm.edit()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("common.edit")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "fast-fade", mode: "out-in" } },
            [
              _vm.currentTabKey == "default"
                ? _c(
                    "div",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-purchase-info-contact", {
                                attrs: { value: _vm.value },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", lg: "5" } },
                            [
                              _c("app-default", {
                                attrs: { value: _vm.value },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", lg: "7" } },
                            [
                              _c("app-info-vat", {
                                attrs: { value: _vm.value },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.currentTabKey == "extra-fields"
                ? _c("app-purchase-info-extra-fields", {
                    attrs: { value: _vm.value },
                  })
                : _c("app-extra-field-tab", {
                    key: "extra-field-" + _vm.tab,
                    attrs: {
                      value: _vm.value.ExtraFields,
                      tab: _vm.extraFieldTabs[_vm.tab - _vm.defaultTabs.length],
                      "name-settings": _vm.extraFieldNamesConfig,
                      readonly: "",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: {
            value: _vm.editLedgersOpen,
            "full-height": _vm.$wf.isSmDown,
          },
        },
        [
          _vm.editLedgersOpen
            ? _c("app-purchase-info-ledgers-card", {
                attrs: { purchase: _vm.value },
                on: {
                  close: function ($event) {
                    _vm.editLedgersOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }